module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.searchResults.length == 0) ? [_c('button', {
    staticClass: "add-author-button",
    on: {
      "click": _vm.showModalAddAuthor
    }
  }, [_vm._v("ADD NEW AUTHOR")]), _vm._v(" "), (_vm.showAuthorModal) ? _c('modal-author', {
    attrs: {
      "modal": _vm.showAuthorModal
    },
    on: {
      "update:modal": function($event) {
        _vm.showAuthorModal = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "searching-author"
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEARCH AUTHOR")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "modal-input",
    attrs: {
      "placeholder": "Start typing to search author..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }, function($event) {
        _vm.isTyping = true
      }]
    }
  })])]), _vm._v(" "), _c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("SLUG")]), _vm._v(" "), _c('md-table-head', [_vm._v("DISPLAY NAME")]), _vm._v(" "), _c('md-table-head', [_vm._v("TAGLINE")])], 1), _vm._v(" "), _vm._l((_vm.authorData), function(item, key) {
    return _c('md-table-row', {
      key: key
    }, [_c('md-table-cell', [_vm._v(_vm._s(item.slug))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.displayName))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.authorTagline))]), _vm._v(" "), _c('md-table-cell', [_c('modal-editauthor', {
      attrs: {
        "passedItem": item
      }
    })], 1), _vm._v(" "), _c('md-table-cell', [_c('modal-delauthor', {
      attrs: {
        "passedItem": item
      }
    })], 1)], 1)
  })], 2), _vm._v(" "), (_vm.authorData.length == 20) ? _c('button', {
    staticStyle: {
      "margin": "5px auto",
      "display": "block",
      "width": "300px"
    },
    on: {
      "click": _vm.moreAuthors
    }
  }, [_vm._v("GET MORE AUTHORS")]) : _vm._e()] : [(_vm.showAuthorModal) ? _c('modal-author', {
    attrs: {
      "modal": _vm.showAuthorModal
    },
    on: {
      "update:modal": function($event) {
        _vm.showAuthorModal = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "searching-author"
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("SEARCH AUTHOR")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "modal-input",
    attrs: {
      "placeholder": "Start typing to search author..."
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }, function($event) {
        _vm.isTyping = true
      }]
    }
  })])]), _vm._v(" "), _c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("SLUG")]), _vm._v(" "), _c('md-table-head', [_vm._v("DISPLAY NAME")]), _vm._v(" "), _c('md-table-head', [_vm._v("TAGLINE")])], 1), _vm._v(" "), _vm._l((_vm.searchResults), function(item, key) {
    return _c('md-table-row', {
      key: key
    }, [_c('md-table-cell', [_vm._v(_vm._s(item.slug))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.displayName))]), _vm._v(" "), _c('md-table-cell', [_vm._v(_vm._s(item.authorTagline))]), _vm._v(" "), _c('md-table-cell', [_c('modal-editauthor', {
      attrs: {
        "passedItem": item
      }
    })], 1), _vm._v(" "), _c('md-table-cell', [_c('modal-delauthor', {
      attrs: {
        "passedItem": item
      }
    })], 1)], 1)
  })], 2)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67e6ba80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/authors.vue
// module id = 667
// module chunks = 1